import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import thunk from 'redux-thunk';

import drugReducer from './reducers/drug.reducer';
import drugsStatisticsReducer from './reducers/drugs-statistics.reducer';
import countryReducer from './reducers/country.reducer';
import companyReducer from './reducers/company.reducer';

const rootReducer = combineReducers({
    drugs: drugReducer,
    drugsStatistics: drugsStatisticsReducer,
    countries: countryReducer,
    company: companyReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

export default store;